import { selectors } from '../../meta/selectors';
import { PureConnect, React } from '../../react';
import { DateTimeText } from '../../shared/date';
import { IEntity, INote, INoteChat, INoteShared, IParticipant, IQuestion, IQuestionDB, IUsergroup, isSharedNote } from '../../types';
import { notesEditor } from '../notes/resource';
import MiniMenu, { MiniMenuItem } from '../../react-toolbox-extended/mini-menu';
import cx from './style.less';
import { Btn } from '../../react-toolbox-redesign/button';
import { participantsResource } from '../../participant/resource';
import { usergroupResource } from '../../usergroup/resource';
import NoteChatCreateControl from '../../note/notechat/editChat';
import { questionsEditor } from '../question/resource';
import { useridResource } from '../../participantid/resource';
import { isNoteMissing } from '../locator/selectors';
import { notesSharedEditor } from '../noteshared/resource';
import TOGGLE_NOTEMENU from '../notes/actions/NOTES_TOGGLE_NOTEMENU';
import { showAnswer, getStatusString, statusNieuw, canChangeQuestion, statusses, showFaction, factionOfNote, getPracticioner, showPracticionerViewModus } from './authmodule/authcheck';
import { notechatResource } from '../notechat/resource';
import { beheerResource } from '../../admin/resource';
import MAXIMIZED from './action/QUESTION_MAXIMIZE';
import questionSelector from './selectors';

function mapParticipantName(participantId: string, allparticipants: IParticipant[]) {
    const participant = allparticipants.qWhere((item) => participantId === item.id);
    return (participant && participant.qAny() ? `${participant[0].name}, ` : '');
}

export const QuestionDetailsNavigator = PureConnect(`QuestionDetailsNavigator`)(
    (state) => ({
        creating: notesEditor.selectors.creating(state),
        updating: notesEditor.selectors.updating(state),
        currentUser: useridResource.selectors.items(state),
        usergroups: usergroupResource.selectors.items(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        isMissing: selectors.pageId(state) === notesEditor.selectors.item(state).pageId && isNoteMissing(state, notesEditor.selectors.item(state).id),
        itemNote: notesEditor.selectors.item(state) as INote,
        itemSharedNote: notesSharedEditor.selectors.item(state) as INoteShared,
        itemQuestion: questionsEditor.selectors.item(state) as IQuestionDB,
        allChats: notechatResource.selectors.items(state),
        showMiniMenu: state.notesReducer.showMiniMenu,
        beheer: beheerResource.selectors.items(state),
    }),
    (dispatch) => ({
        doDelete: (item: INote) => {
            dispatch(TOGGLE_NOTEMENU({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(notesEditor.actions.DELETE({ item }));
        },
        doEdit: (item: INote) => {
            dispatch(TOGGLE_NOTEMENU({ showMiniMenu: false, itemMiniMenu: undefined }));
            dispatch(notesEditor.actions.UPDATE({ item }));
        },
        toggleMiniMenu: (showMiniMenu: boolean, itemMiniMenu?: IEntity) => {
            dispatch(TOGGLE_NOTEMENU({ showMiniMenu, itemMiniMenu: undefined }));
        },
        cancelNoteRead: () => dispatch(notesEditor.actions.READ_CANCEL({})),
        cancelSharedNoteRead: () => dispatch(notesSharedEditor.actions.READ_CANCEL({})),
    }),
    ({ itemNote, itemSharedNote, itemQuestion, allChats, allparticipants, allparticipantsgroups, usergroups, currentUser, doEdit, cancelNoteRead, cancelSharedNoteRead, doDelete, showMiniMenu, toggleMiniMenu, beheer }) => {

        var item = itemSharedNote && !!isSharedNote(itemSharedNote)? itemSharedNote: itemNote;            
        const toggle = () => {
            showMiniMenu = !showMiniMenu;
            toggleMiniMenu(showMiniMenu, item);
        };

        const setMiniMenu = (showMenu: boolean) => {
            toggleMiniMenu(showMenu, item);
        };

        var currentUserId =  currentUser.length > 0 ? currentUser[0].id : '';
        var admin = beheer && beheer.qAny() && beheer.qFirst();
        var status= statusNieuw;
        var canChange = false;
        if (itemQuestion) {      
            status = itemQuestion.status ? itemQuestion.status: statusNieuw;
            canChange = !!itemQuestion && canChangeQuestion(statusses, status, currentUserId, usergroups, admin);
        }
        var disableDelete = (allChats ? allChats.qWhere((itm: INoteChat) => itemQuestion.id === itm.noteId && itm.userId!==currentUserId).qAny() : false) || 
        (itemNote && itemNote.userId!==currentUserId) ||
        (itemQuestion && itemQuestion.status && itemQuestion.status>statusNieuw); 

        const itms: MiniMenuItem[] =
            canChange && !disableDelete?
            [{
                name: 'Bewerken', iconName: 'edit', key: '1', functionitem: item, function: (item: INote) =>
                    doEdit(item),
            },
            {
                name: 'Verwijderen', iconName: 'delete', key: '2', functionitem: item, function: (item: INote) =>
                    doDelete(item),
            }]: !disableDelete?
            [
            {
                name: 'Verwijderen', iconName: 'delete', key: '2', functionitem: item, function: (item: INote) =>
                    doDelete(item),
            }]: canChange ?
            [{
                name: 'Bewerken', iconName: 'edit', key: '1', functionitem: item, function: (item: INote) =>
                    doEdit(item),
            }]: null;

        var status=itemQuestion&&itemQuestion.status ? itemQuestion.status: statusNieuw;

        return (
            <div className={cx('details', item.isquestion? '': 'wcag-invisible')}>
                <section role="contentinfo" aria-label={'Sluit sectie'} className={cx('content-container')}>
                    <div className={cx('button-container')}>
                        <Btn
                            type="button"
                            className={cx('btn-icon-text_back', 'icon_arrow-back')}
                            aria-label={'Terug gaan'}
                            aria-haspopup={true}
                            tabIndex={0}
                            onClick={() => { setMiniMenu(false); !!isSharedNote(itemSharedNote)? cancelSharedNoteRead():cancelNoteRead(); }}
                            disabled={false}>
                            <span>Terug</span>
                        </Btn>
                        <div className={cx('menu', itms && itms.length ? '': 'wcag-invisible')}>
                            <MiniMenu showMiniMenu={showMiniMenu}
                                toggleMiniMenu={() => toggle()}
                                items={itms}>
                            </MiniMenu>
                        </div>
                    </div>

                </section>
                <section className={cx('details-content-container', 'flyover')}>
                    <div className={cx('details-top-container')}>

                        <div className={cx('details-title-container')} onClick={() => setMiniMenu(false)}>
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container', item.isquestion ? 'question' : 'message')}></span>
                            </div>
                            <div className={cx('text-created-container')}>
                                <div className={cx('text-created-container-top')}>{item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'}</div>
                                <div className={cx('text-created-container-bottom')}><DateTimeText date={item.created} /></div>
                            </div>
                        </div>
                    </div>
                    <div className={cx('middle-container')} onClick={() => setMiniMenu(false)}>
                        <div className={cx('made-by-container')}>
                            <div className={cx('text-created-container-top')}>Aangemaakt door</div>
                            <div className={cx('text-created-container-bottom')}>{mapParticipantName(item.userId, allparticipants)}</div>
                        </div>
                        <div className={cx('status-container')}>
                            <div className={cx('status-container-top')}>Status</div>
                            <div id={`id-ref-${item.id}`} className={cx('status-list', 'status'+ (status).toString())}><span className={cx('status-list-text')}>{getStatusString(status)}</span></div>
                        </div>
                        
                        <div className={cx('practicioner-container', !showPracticionerViewModus(status) ? 'wcag-invisible' : '')}>
                            <div className={cx('practicioner-container-top')}>Behandelaar</div>
                            <div id={`id-ref-beh-${item.id}`} className={cx('cls-practicioner')}><span className={cx('practicioner-text')}>{getPracticioner(allparticipants, itemQuestion.practicionerId)}</span></div>
                        </div> 
                    </div>

                    {showFaction(status, item.userId, currentUserId, allparticipantsgroups) ? 
                        <div className={cx('middle-shared-container')} onClick={() => setMiniMenu(false)}>
                            <div className={cx('shared-with-label')}>Fractie</div>
                            <div className={cx('list-of-shared')}>
                                {factionOfNote(item, allparticipantsgroups)}
                            </div>
                        </div>
                        : null
                    }

                    <div className={cx('bottom-container')} onClick={() => setMiniMenu(false)}>
                        <div className={cx('note-label')}>Vraag</div>
                        <span className={cx('note-text')}>{item.text}</span>
                    </div>

                    <div className={cx('bottom-answer-container', (!showAnswer(status, currentUserId, usergroups)) ? 'wcag-invisible' : '')}>
                        <div className={cx('answer-label')}>Antwoord vanuit Concern</div>
                        <span className={cx('answer-text')}>{itemQuestion.antwoordConcern}</span>
                    </div>
                    <NoteChatCreateControl />
                </section>
                
            </div>

        );
    });

interface IPropsDetailsModal {
    item: INote | INoteShared | IQuestion;
    itemQuestion: IQuestionDB;
}

export const QuestionDetailsControl = PureConnect<any | IPropsDetailsModal>(`NoteDetailsControl`)(
    (state) => ({
        currentUser: useridResource.selectors.items(state),
        usergroups: usergroupResource.selectors.items(state),
        allparticipants: participantsResource.selectors.items(state).qSelect((item) => item as IParticipant),
        allparticipantsgroups: usergroupResource.selectors.items(state).qSelect((item) => item as IUsergroup),
        ismaximized: questionSelector.ismaximized(state),
    }),
    (dispatch) => ({
        maximize: (maximized: boolean) => dispatch(MAXIMIZED({ maximized: maximized })),
     }),
    ({ item, itemQuestion, currentUser, usergroups, allparticipants, allparticipantsgroups, ismaximized, maximize}) => {
        var status=itemQuestion&&itemQuestion.status ? itemQuestion.status: statusNieuw;
        var currentUserId =  currentUser.length > 0 ? currentUser[0].id : '';

        return (
            <div className={cx('details')}>
                <section role="contentinfo" aria-label={'Sluit sectie'} className={cx('content-container')}>
                    <span className={cx('expand_button-container')}> 
                        <button type="button" className={cx('btn', 'icon-btn', !ismaximized ? 'expand' : 'collapse')} onClick={()=> {maximize( !ismaximized );}}>
                            <span className={cx('arrow-expand-icon')}></span>
                        </button>
                    </span>
                    <div className={cx('details-top-container')} tabIndex={0}>
                        <div className={cx('details-title-container')}>
                            <span className={cx('title-text-action')}>{'Technische vraag raadplegen'}</span>
                            
                            <div className={cx('icon-left-container')}>
                                <span className={cx('icon-container', 'question')}></span>
                            </div>
                            <div className={cx('text-created-container')}>
                                <div className={cx('text-created-container-top')}>{item.isquestion ? 'TECHNISCHE VRAAG' : 'NOTITIE'}</div>
                                <div className={cx('text-created-container-bottom')}><DateTimeText date={item.created} /></div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className={cx('details-content-container', 'modal', !ismaximized ? 'normal' : 'maximized')}>
                    <div className={cx('middle-container')}>
                        <div className={cx('made-by-container')}>
                            <div className={cx('text-created-container-top')}>Aangemaakt door</div>
                            <div className={cx('text-created-container-bottom')}><span className={cx('created-text')}>{mapParticipantName(item.userId, allparticipants)}</span></div>
                        </div>
                        <div className={cx('status-container')}>
                            <div className={cx('status-container-top')}>Status</div>
                            <div id={`id-ref-${item.id}`} className={cx('status-list', 'status'+ (status).toString())}><span className={cx('status-list-text')}>{getStatusString(status)}</span></div>
                        </div>
                        <div className={cx('practicioner-container', !showPracticionerViewModus(status) ? 'wcag-invisible' : '')}>
                            <div className={cx('practicioner-container-top')}>Behandelaar</div>
                            <div id={`id-ref-beh-${item.id}`} className={cx('practicioner-container-bottom')}><span className={cx('practicioner-text')}>{getPracticioner(allparticipants, itemQuestion.practicionerId)}</span></div>
                        </div>                        
                    </div>

                    {showFaction(status, item.userId, currentUserId, allparticipantsgroups) ? 
                        <div className={cx('middle-shared-container')}>
                            <div className={cx('shared-with-label')}>Fractie</div>
                            <div className={cx('list-of-shared')}>
                                {factionOfNote(item, allparticipantsgroups)}
                            </div>
                        </div>
                        : null
                    }

                    <div className={cx('bottom-container')}>
                        <div className={cx('note-label')}>Vraag</div>
                        <span className={cx('note-text')}>{item.text}</span>
                    </div>
                    <div className={cx('bottom-answer-container', (!showAnswer(itemQuestion.status, currentUserId, usergroups)) ? 'wcag-invisible' : '')}>
                        <div className={cx('answer-label')}>Antwoord vanuit Concern</div>
                        <span className={cx('answer-text')}>{itemQuestion.antwoordConcern}</span>
                    </div>                            
                    <NoteChatCreateControl />
                </section>

            </div>

        );
    });



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/details.tsx